import { Staff } from '../types';

/**
 * Dịch vụ xác thực và kiểm tra quyền
 */
const AuthService = {
  /**
   * Lấy thông tin người dùng hiện tại
   */
  getCurrentUser: (): Staff | null => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    try {
      return JSON.parse(userStr);
    } catch (error) {
      console.error('Lỗi khi parse thông tin người dùng:', error);
      return null;
    }
  },

  /**
   * Kiểm tra người dùng hiện tại có phải admin không
   */
  isAdmin: (): boolean => {
    const user = AuthService.getCurrentUser();
    return user?.role === 'admin';
  },

  /**
   * Đăng xuất khỏi hệ thống
   */
  logout: (): void => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/auth/login';
  },

  /**
   * Kiểm tra token có hết hạn không
   */
  isTokenExpired: (): boolean => {
    const token = localStorage.getItem('token');
    if (!token) return true;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp && payload.exp < currentTime;
    } catch (error) {
      console.error('Lỗi khi kiểm tra token:', error);
      return true;
    }
  },

  /**
   * Lấy thời gian hết hạn của token (tính bằng giây)
   */
  getTokenExpirationTime: (): number | null => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp || null;
    } catch (error) {
      console.error('Lỗi khi lấy thời gian hết hạn token:', error);
      return null;
    }
  },

  /**
   * Kiểm tra có quyền truy cập tài nguyên không
   */
  hasPermission: (resourceType: string): boolean => {
    const user = AuthService.getCurrentUser();
    if (!user) return false;

    // Staff có thể truy cập tài nguyên khách hàng, đơn hàng và log
    if (user.role === 'staff') {
      return ['customer', 'order', 'log'].includes(resourceType);
    }

    // Admin có thể truy cập tất cả tài nguyên
    return true;
  }
};

export default AuthService; 